<template>
  <div class="flex items-center">
    <chart-legend-icon :type="type" :has-tooltip="!!chartData.tooltip" :tooltip-position="tooltipPosition">
      <template v-if="!!chartData.tooltip" #tooltip>
        <h4 class="font-semibold">{{ chartData.label }}</h4>
        <span v-html="chartData.tooltip" />
      </template>
    </chart-legend-icon>

    <span v-if="showLabel" class="ml-1 text-gray-dark text-sm">
      {{ chartData.label }}
    </span>
  </div>
</template>

<script>

import ChartLegendIcon from './ChartLegendIcon'
import chartLabels from '@/utils/chart-labels'

export default {
  name: 'ChartLegend',
  components: { ChartLegendIcon },

  props: {
    type: {
      type: String,
      required: true
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    tooltipPosition: {
      type: String,
      default: 'top'
    }
  },

  computed: {
    chartData() {
      return chartLabels[this.type] || { color: 'transparent' }
    }
  }
}
</script>
